const validate = require("jquery-validation")

export function formAjax(param) {
	var validator = $(".form-ajax");

	validator.each(function () {
		$(this).validate(
			{
				rules: {
					name: {
						required: true,
						minlength: 3
					},
					phone: {
						required: true,
						minlength: 14
					},
					email: {
						required: true,
						email: true
					},
					message: {
						required: true,
						minlength: 5
					},
				},
				messages: {
					name: {
						required: "Por favor, informe seu nome",
						minlength: "O nome deve ter pelo menos 3 caracteres"
					},
					phone: {
						required: "Por favor, informe seu telefone",
						minlength: "O telefone deve ter DDD e número válido"
					},
					email: {
						required: "É necessário informar um e-mail",
						email: "É necessário informar um e-mail válido",
					},
					message: {
						required: "Campo obrigatório",
						minlength: "O nome deve ter pelo menos 5 caracteres"
					}
				},

			}
		);
	});

}